import { useEffect } from 'react'

import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'

type Params = CustomFormViewerQuestionProps

export default function useCustomFormGetDefaultValue({ question, questionKey, formMethods }: Params) {
  const questionDefaultValue = question?.default_value || []

  const defaultValue = questionDefaultValue[0]

  useEffect(() => {
    if (formMethods?.setValue && defaultValue) {
      formMethods?.setValue(questionKey, defaultValue)
    }
  }, [])

  return { defaultValue }
}
